import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { VisitTagProps } from './visitAttachmentsTypes';

export const VisitTag = ({ visit, originalVisit, onRemove }: VisitTagProps) => {
  if (!originalVisit) return null;

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onRemove(originalVisit);
  };

  return (
    <div
      key={visit.id}
      className="vai-bg-blue-100 vai-text-blue-800 vai-text-xs vai-rounded vai-px-2 vai-py-1 vai-flex vai-items-center"
    >
      <span>{visit.date}</span>
      <button
        type="button"
        onClick={handleRemove}
        className="vai-ml-1 vai-text-blue-500 hover:vai-text-blue-700"
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};
